export class GlobalCustomer {
    ID?: number;
    Code?: string;
    Name?: string;
    FullName?: string;
}

export default GlobalCustomer;